@if (model()) {
  <div class="d-flex flex-wrap gap-4">
    <app-mdb-button
      [text]="'CUSTOMERS.ADD_CONTACT'"
      [iconClass]="'fas fa-plus'"
      (onClick)="openAddContactModal()"></app-mdb-button>
  </div>
  <app-table
    [columns]="childrenColumns"
    [data]="model()?.children ?? []"
    [pagination]="null"></app-table>
}
